import React from "react";
import Icon, { type IconName } from "../../../components/AppIcon";

interface TenantStatsCardProps {
	title: string;
	value: string | number;
	change?: string;
	changeType?: "increase" | "decrease";
	icon: IconName;
	color?: "primary" | "success" | "warning" | "error";
}

const TenantStatsCard: React.FC<TenantStatsCardProps> = ({
	title,
	value,
	change,
	changeType,
	icon,
	color = "primary",
}) => {
	const getColorClasses = (color: string) => {
		switch (color) {
			case "success":
				return "bg-success/10 text-success border-success/20";
			case "warning":
				return "bg-warning/10 text-warning border-warning/20";
			case "error":
				return "bg-error/10 text-error border-error/20";
			default:
				return "bg-primary/10 text-primary border-primary/20";
		}
	};

	return (
		<div className="bg-card border border-border rounded-lg p-4 sm:p-5 card-shadow overflow-hidden">
			<div className="flex items-center justify-between mb-3 gap-2">
				<div
					className={`p-2 sm:p-2.5 rounded-lg flex-shrink-0 ${getColorClasses(
						color,
					)}`}
				>
					<Icon name={icon} size={18} className="sm:w-5 sm:h-5" />
				</div>
				{change && (
					<div
						className={`flex items-center space-x-1 text-xs sm:text-sm flex-shrink-0 ${
							changeType === "increase" ? "text-success" : "text-error"
						}`}
					>
						<Icon
							name={changeType === "increase" ? "TrendingUp" : "TrendingDown"}
							size={14}
							className="sm:w-4 sm:h-4"
						/>
						<span className="whitespace-nowrap">{change}</span>
					</div>
				)}
			</div>
			<div className="min-w-0">
				<h3 className="text-lg sm:text-xl font-bold text-foreground mb-1 truncate">
					{value}
				</h3>
				<p className="text-xs sm:text-sm text-muted-foreground truncate">
					{title}
				</p>
			</div>
		</div>
	);
};

export default TenantStatsCard;
